<app-esqueleto-tableros>
  <div titulo class="encabezadosSeparacion"
    [matTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)"
    [appOverflowTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)">
    <span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
    <span class="bullSeparation">&bull;</span>
    <span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
  </div>

  <div contenido class="zonaClass">
    <app-contenedor-elementos [header]="{title: 'gestion.admin.altaPlanes.planEs' |translate}">
      <mat-icon iconos class="iconoMen" [ngStyle]="{'color':'gray'}" [matMenuTriggerFor]="menu2"
      >more_vert</mat-icon>
      <mat-menu #menu2="matMenu">
        @if (planeacion) {
        <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="abrirFormAgregar(planeacion)">
          <mat-icon [ngStyle]="{'color':'gray'}">add_circle</mat-icon>
          <span>{{'gestion.admin.altaPlanes.agregarPlaneacion' | translate}}</span>
        </button>
        }
        <button (click)="exportar_excel()" class="mat-menu-item" mat-menu-item class="w3-caja-menu">
          <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
          <span>{{'gestion.admin.altaPlanes.exportarXlsx' | translate}}</span>
        </button>
      </mat-menu>

      <div body class="cuerpoTabla">
        @if (!mostabla) {
        <app-skeleton-table/>
        } @else {
        <table class="tabla-aleema">
          <thead>
            <tr>
              <th style="min-width: 20vw; max-width: 20vw;">
                {{'gestion.admin.altaPlanes.nombre' | translate}}</th>
              <th style="min-width: 20vw; max-width: 20vw;">
                {{'gestion.admin.altaPlanes.responsable' | translate}}</th>
              <th style="min-width: 11.5vw; max-width: 11.5vw;">
                {{'gestion.admin.altaPlanes.fechaInicial' | translate}} </th>
              <th style="min-width: 11.5vw; max-width: 11.5vw;">
                {{'gestion.admin.altaPlanes.fechaFinal' | translate}} </th>
              <th style="min-width: 16vw; max-width: 16vw;">
                {{'gestion.admin.altaPlanes.institucion' | translate}} </th>
              <th style="min-width: 8vw; max-width: 8vw;">
                {{'gestion.admin.altaPlanes.envioReportes' | translate}} </th>
              <th style="min-width: 12vw; max-width: 12vw;">
                {{'gestion.admin.altaPlanes.edicionPeriodos' | translate}} </th>
              <th style="min-width: 6vw; max-width: 6vw;">
                {{'gestion.admin.altaPlanes.semaforo' | translate}} </th>
              <th style="min-width: 6vw; max-width: 6vw;">
                {{'gestion.admin.altaPlanes.editar' | translate}} </th>
              <th style="min-width: 6vw; max-width: 6vw;">
                {{'gestion.admin.altaPlanes.eliminar' | translate}} </th>
              <th>
                {{'gestion.admin.altaPlanes.configuracion' | translate}} </th>
            </tr>
          </thead>
          <tbody>
            @for (ele of planeacion; track ele; let i = $index) {
            <tr>
              <td class="textoOverFlow" style="min-width: 20vw; max-width: 20vw;"
                [matTooltip]="ele.nombre" [appOverflowTooltip]="ele.nombre">{{ele.nombre}}</td>
              <td class="borderAllLow marginIzq textoOverFlow" style="min-width: 20vw; max-width: 20vw;"
              [matTooltip]="escribirres(ele.responsible)" [appOverflowTooltip]="escribirres(ele.responsible)">
                {{escribirres(ele.responsible)}}</td>
              <td class="w3-center"> {{escribirmes(ele.fecha_inicio)}}</td>
              <td class="w3-center"> {{escribirmes(ele.fecha_fin)}}</td>
              <td class="textoOverFlow" style="min-width: 16vw; max-width: 16vw;" [matTooltip]="obtInst(ele)"
                [appOverflowTooltip]="obtInst(ele)">{{obtInst(ele)}}</td>
              <td class="w3-center">
                <mat-checkbox [checked]="ele.enableMailReports" (change)="activacionNotify(ele)"></mat-checkbox>
              </td>
              <td class="w3-center">
                <mat-checkbox [checked]="ele.isActive" (change)="activacionEdicion(ele)"></mat-checkbox>
              </td>
              <td class="w3-center">
                @if (semaforo) {
                <div class="iconoMen" style="cursor: pointer;" (click)="abrirFormSem(ele)">
                  <mat-icon [ngStyle]="{'color':'gray'}">visibility</mat-icon>
                </div>
                }
              </td>
              <td class="w3-center">
                <div class="iconoMen" style="cursor: pointer;" (click)="abrirFormEdit(ele)">
                  <mat-icon [ngStyle]="{'color':'gray'}">edit</mat-icon>
                </div>
              </td>
              <td class="w3-center">
                <div class="iconoMen" style="cursor: pointer;" (click)="alertas('eliminarPlan',ele)">
                  <mat-icon [ngStyle]="{'color':'gray'}">delete</mat-icon>
                </div>
              </td>
              <td class="w3-center">
                <div class="iconoMen" style="cursor: pointer;" [matMenuTriggerFor]="configurarMenu">
                  <mat-icon [ngStyle]="{'color':'gray'}">settings</mat-icon>
                </div>
                <mat-menu #configurarMenu="matMenu">
                  <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="isActiveperspectivas(ele)">
                    <span>{{'gestion.admin.altaPlanes.perspectivas' | translate}}</span>
                  </button>
                  <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="isActivefilosofia(ele)">
                    <span>{{'gestion.admin.altaPlanes.filosofiaCorporativa' | translate}}</span>
                  </button>
                  <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="isActiveMatrizfloa(ele)">
                    <span>{{'gestion.admin.altaPlanes.matrizFoda' | translate}}</span>
                  </button>
                  <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="isActiveObjetivos(ele)">
                    <span>{{'gestion.admin.altaPlanes.objetivos' | translate}}</span>
                  </button>
                  <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="isActiveIndicadores(ele)">
                    <span>{{'gestion.admin.altaPlanes.indicadoresMetas' | translate}}</span>
                  </button>
                  <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="isActiveAlineamiento(ele)">
                    <span>{{'gestion.admin.altaPlanes.alineamientoEstrategico' | translate}}</span>
                  </button>
                  <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="isActiveProyectos(ele)">
                    <span>{{'gestion.admin.altaPlanes.proyectosEstrategicos' | translate}}</span>
                  </button>
                  <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="isActiveCuadro(ele)">
                    <span>{{'gestion.admin.altaPlanes.cuadroMandoIntegral' | translate}}</span>
                  </button>
                </mat-menu>
              </td>
            </tr>
            }
          </tbody>
        </table>
        }
      </div>
    </app-contenedor-elementos>
  </div>

</app-esqueleto-tableros>
<div class="workSpace">

  <!--CONTENIDO DEL TABLERO-->
  <div class="w3-row workSpaceTab">
    <div class="w3-row w3-white" style="margin-top: 1vh;">
      
    </div>
  </div>

  <!-- MODALES -->

  <!-- MODAL AGREGAR - NUEVA VERSIÓN -->
  <app-modal [isOpen]="modal" [cerrar]="false" (close)="cerrarForm()">
    <div modal-header>
      {{'gestion.admin.altaPlanes.nuevaPlaneacion' | translate}}
    </div>

    <div modal-body style="padding-left: 1vw; padding-right: 1vw;">
      <form [formGroup]="formNuevo" (ngSubmit)="alertas('guardar')">

        <div class="form-group">
          <label for="nombre" class="form-label">
            {{'gestion.admin.altaPlanes.nombre' | translate}} <span>*</span>
          </label>
          <input id="nombre" formControlName="inputName" type="text" class="form-input anchosInputs"
            placeholder="{{'gestion.admin.altaPlanes.nombrePlaceholder' | translate}}" required>
        </div>

        <div class="form-group">
          <label for="diasLaborables" class="form-label">
            {{'gestion.admin.altaPlanes.diasLaborables' | translate}} <span>*</span>
          </label>
          <select id="diasLaborables" formControlName="inputDays" class="contentSelect anchosInputs" required
            (change)="filtrodias(fn['inputDays'].value)">
            <option value="" disabled selected>{{'gestion.admin.altaPlanes.selectDiasLaborables'
              | translate}}</option>
            @for (dia of diasLab; track dia) {
            <option value="{{dia}}">{{dia}}</option>
            }
          </select>
        </div>

        <div style="display: flex; gap: 1%; width: 100%;">
          <div class="form-group" style="flex: 0 0 47% !important;">
            <label for="fechaInicial" class="form-label">
              {{'gestion.admin.altaPlanes.fechaInicial' | translate}} <span>*</span>
              <small style="color: #666; font-weight: normal;">
                ({{diaslaborablesSelect || 'Lunes-Viernes'}})
              </small>
            </label>
            <input type="date" formControlName="inputFechaIni" id="fechaInicial" class="form-input anchosInputs"
              [disabled]="true" class="form-input" required (change)="onDateChange($event, 'inputFechaIni', formNuevo)"
              (input)="onDateInput($event, 'inputFechaIni', formNuevo)">
          </div>
          <div class="form-group" style="flex: 0 0 47% !important;">
            <label for="fechaFinal" class="form-label">
              {{'gestion.admin.altaPlanes.fechaFinal' | translate}} <span>*</span>
              <small style="color: #666; font-weight: normal;">
                ({{diaslaborablesSelect || 'Lunes-Viernes'}})
              </small>
            </label>
            <input type="date" formControlName="inputFechaFin" id="fechaFinal" [disabled]="true" class="form-input "
              required (change)="onDateChange($event, 'inputFechaFin', formNuevo)"
              (input)="onDateInput($event, 'inputFechaFin', formNuevo)">
          </div>
        </div>

        <div style="display: flex; gap: 1%; width: 100%;">
          <div class="form-group" style="flex: 0 0 49% !important;">
            <label for="institucion" class="form-label">
              {{'gestion.admin.altaPlanes.institucion' | translate}} <span>*</span>
            </label>
            <select id="institucion" formControlName="inputIntstitucion" class="contentSelect anchosInputs" required>
              <option value="" disabled selected>
                {{'gestion.admin.altaPlanes.selectInstitucion' | translate}}</option>
              @for (ins of instituciones; track ins.id) {
              <option value="{{ins.id}}">{{ins.acronimo}}</option>
              }
            </select>
          </div>
          <div class="form-group" style="flex: 0 0 33% !important; display: flex; align-items: center;">
            <label for="activa" class="form-label">
              {{'gestion.admin.altaPlanes.activa' | translate}}
            </label>
            <input id="activa" type="checkbox" [(ngModel)]="isActiveSelect" [ngModelOptions]="{standalone: true}">
            <label for="activa" style="margin-left: 8px;">{{'gestion.admin.altaPlanes.activa' |
              translate}}</label>
          </div>
        </div>

        <div class="form-group">
          <label for="responsable" class="form-label">
            {{'gestion.admin.altaPlanes.responsable' | translate}} <span>*</span>
          </label>
          <select id="responsable" formControlName="inputResponsble" class="contentSelect anchosInputs" required>
            <option value="" disabled selected>{{'gestion.admin.altaPlanes.selectResponsable' |
              translate}}</option>
            @for (obj of responsables; track obj.id) {
            @if (existe(obj.institucionId)) {
            <option value="{{obj.id}}">{{obj.nombre}}</option>
            }
            }
          </select>
        </div>

        <div class="form-group">
          <label for="semaforos" class="form-label">
            {{'gestion.admin.altaPlanes.cantidadSemaforos' | translate}} <span>*</span>
          </label>
          <select id="semaforos" formControlName="inputNumColor" class="contentSelect anchosInputs" required
            (change)="elegirSem()">
            <option value="" disabled selected>{{'gestion.admin.altaPlanes.selectCantidad' |
              translate}}</option>
            <option value="tres">
              {{'gestion.admin.altaPlanes.tresColores' | translate}}</option>
            <option value="cuatro">
              {{'gestion.admin.altaPlanes.cuatroColores' | translate}}</option>
            <option value="cinco">
              {{'gestion.admin.altaPlanes.cincoColores' | translate}}</option>
          </select>
        </div>

        @for (sem of newsemaforo; track sem; let i = $index) {
        <div style="display: flex; gap: 1%; width: 70%;">
          <div class="form-group">
            <label for="valor1Sem_{{i}}" class="form-label">
              {{'gestion.admin.altaPlanes.valor1' | translate}}
            </label>
            <input id="valor1Sem_{{i}}" type="number" class="form-input anchosInputsShort"
              formControlName="inputVal1Sem{{i}}" placeholder="{{'gestion.admin.altaPlanes.valorMinimo' | translate}}"
              value="{{sem.valor_00}}">
          </div>
          <div class="form-group">
            <label for="valor2Sem_{{i}}" class="form-label">
              {{'gestion.admin.altaPlanes.valor2' | translate}}
            </label>
            <input id="valor2Sem_{{i}}" type="number" class="form-input anchosInputsShort"
              formControlName="{{i === (newsemaforo.length-1)? 'inputVal2Sem4':'inputVal2Sem'+i}}"
              placeholder="{{'gestion.admin.altaPlanes.valorMaximo' | translate}}" (input)="intNumero(i)"
              value="{{sem.valor_01}}">
          </div>
          <div class="form-group">
            <label for="colorSem_{{i}}" class="form-label">
              {{'gestion.admin.altaPlanes.color' | translate}}
            </label>
            <select id="colorSem_{{i}}" formControlName="inputColor{{i}}" class="contentSelect anchosInputsShort"
              required>
              <option value="" disabled>{{'gestion.admin.altaPlanes.selectColor' | translate}}</option>
              <option value="rojo" (click)="setcolor(i, 'rojo')">🔴 {{'gestion.admin.altaPlanes.rojo' | translate}}
              </option>
              <option value="naranja" (click)="setcolor(i, 'naranja')">🟠 {{'gestion.admin.altaPlanes.naranja' |
                translate}}</option>
              <option value="amarillo" (click)="setcolor(i, 'amarillo')">🟡 {{'gestion.admin.altaPlanes.amarillo' |
                translate}}</option>
              <option value="verde" (click)="setcolor(i, 'verde')">🟢 {{'gestion.admin.altaPlanes.verde' | translate}}
              </option>
              <option value="azul" (click)="setcolor(i, 'azul')">🔵 {{'gestion.admin.altaPlanes.azul' | translate}}
              </option>
            </select>
          </div>
        </div>
        }

      </form>
    </div>

    <div modal-footer>
      <div class="w3-right">
        <div class="botonesModales" ngClass="{{puede_guardar()}}">
          <button mat-flat-button color="success" (click)="alertas('guardar')" style="height: 4vh;">
            {{'gestion.admin.altaPlanes.guardar' | translate}}
          </button>
        </div>
        <div class="botonesModales">
          <button mat-stroked-button color="success2" (click)="cerrarForm()" style="height: 4vh;">
            {{'gestion.admin.altaPlanes.cancelar' | translate}}
          </button>
        </div>
      </div>
    </div>
  </app-modal>

  <!-- EDITAR - NUEVA VERSIÓN -->
  <app-modal [isOpen]="modal2" (close)="cerrarForm()">
    <div modal-header>
      {{'gestion.admin.altaPlanes.editarPlaneacion' | translate}}
    </div>

    <div modal-body>
      <form [formGroup]="formEdit" (ngSubmit)="alertas('editar')">

        <div class="form-group">
          <label for="nombreEdit" class="form-label">
            {{'gestion.admin.altaPlanes.nombre' | translate}} <span>*</span>
          </label>
          <input id="nombreEdit" formControlName="inputName" type="text" class="form-input anchosInputs"
            placeholder="{{'gestion.admin.altaPlanes.nombrePlaceholder' | translate}}" required>
        </div>

        <div class="form-group">
          <label for="diasLaborablesEdit" class="form-label">
            {{'gestion.admin.altaPlanes.diasLaborables' | translate}} <span>*</span>
          </label>
          <select id="diasLaborablesEdit" formControlName="inputDays" class="contentSelect anchosInputs" required
            (change)="filtrodias(fe['inputDays'].value)">
            <option value="" disabled>{{'gestion.admin.altaPlanes.selectDiasLaborables' |
              translate}}</option>
            @for (dia of diasLab; track dia) {
            <option value="{{dia}}">{{dia}}</option>
            }
          </select>
        </div>

        <div style="display: flex; gap: 1%; width: 100%;">
          <div class="form-group" style="flex: 0 0 47% !important;">
            <label for="fechaInicialEdit" class="form-label">
              {{'gestion.admin.altaPlanes.fechaInicial' | translate}} <span>*</span>
              <small style="color: #666; font-weight: normal;">
                ({{diaslaborablesSelect || 'Lunes-Viernes'}})
              </small>
            </label>
            <input type="date" formControlName="inputFechaIni" id="fechaInicialEdit" [disabled]="true"
              class="form-input" required (change)="onDateChange($event, 'inputFechaIni', formEdit)"
              (input)="onDateInput($event, 'inputFechaIni', formEdit)">
          </div>
          <div class="form-group" style="flex: 0 0 47% !important;">
            <label for="fechaFinalEdit" class="form-label">
              {{'gestion.admin.altaPlanes.fechaFinal' | translate}} <span>*</span>
              <small style="color: #666; font-weight: normal;">
                ({{diaslaborablesSelect || 'Lunes-Viernes'}})
              </small>
            </label>
            <input type="date" formControlName="inputFechaFin" id="fechaFinalEdit" [disabled]="true" class="form-input"
              required (change)="onDateChange($event, 'inputFechaFin', formEdit)"
              (input)="onDateInput($event, 'inputFechaFin', formEdit)">
          </div>
        </div>

        <div style="display: flex; gap: 1%; width: 100%;">
          <div class="form-group" style="flex: 0 0 49% !important;">
            <label for="institucionEdit" class="form-label">
              {{'gestion.admin.altaPlanes.institucion' | translate}} <span>*</span>
            </label>
            <select id="institucionEdit" formControlName="inputIntstitucion" class="contentSelect anchosInputs"
              required>
              <option value="" disabled>{{'gestion.admin.altaPlanes.selectInstitucion' |
                translate}}</option>
              @for (ins of instituciones; track ins.id) {
              <option value="{{ins.id}}">{{ins.acronimo}}</option>
              }
            </select>
          </div>
          <div class="form-group" style="flex: 0 0 33% !important; display: flex; align-items: center;">
            <label for="activaEdit" class="form-label">
              {{'gestion.admin.altaPlanes.activa' | translate}}
            </label>
            <input id="activaEdit" type="checkbox" [(ngModel)]="isActiveSelect" [ngModelOptions]="{standalone: true}">
            <label for="activaEdit" style="margin-left: 8px;">{{'gestion.admin.altaPlanes.activa' |
              translate}}</label>
          </div>
        </div>

        <div class="form-group">
          <label for="responsableEdit" class="form-label">
            {{'gestion.admin.altaPlanes.responsable' | translate}} <span>*</span>
          </label>
          <select id="responsableEdit" formControlName="inputResponsble" class="contentSelect anchosInputs" required>
            <option value="" disabled>{{'gestion.admin.altaPlanes.selectResponsable' | translate}}</option>
            @for (obj of responsables; track obj.id) {
            @if (existe(obj.institucionId)) {
            <option value="{{obj.id}}">{{obj.nombre}}</option>
            }
            }
          </select>
        </div>

      </form>
    </div>

    <div modal-footer>
      <div class="w3-right">
        <div class="botonesModales" [ngClass]="{'w3-disabled': !formEdit.valid}">
          <button mat-flat-button color="success" (click)="alertas('editar')" style="height: 4vh;">
            {{'gestion.admin.altaPlanes.guardar' | translate}}
          </button>
        </div>
        <div class="botonesModales">
          <button mat-stroked-button color="success2" (click)="cerrarForm()" style="height: 4vh;">
            {{'gestion.admin.altaPlanes.cancelar' | translate}}
          </button>
        </div>
      </div>
    </div>
  </app-modal>


  <!-- MODAL SEMAFORO - NUEVA VERSIÓN -->
  <app-modal [isOpen]="modal3" (close)="cerrarForm()">
    <div modal-header>
      {{'gestion.admin.altaPlanes.configuracionSemaforo' | translate}}
    </div>

    <div modal-body>
      <form [formGroup]="formSemaforo" (ngSubmit)="alertas('editSem')">

        <div class="form-group">
          <label for="semaforosEdit" class="form-label">
            {{'gestion.admin.altaPlanes.cantidadSemaforos' | translate}} <span>*</span>
          </label>
          <select id="semaforosEdit" formControlName="inputNumColor" class="contentSelect anchosInputs" required
            [ngClass]="puedeSelec()" (click)="cambioEdit()" (change)="elegirSemEdit()">
            <option value="" disabled>{{'gestion.admin.altaPlanes.selectCantidad' | translate}}</option>
            <option value="tres">{{'gestion.admin.altaPlanes.tresColores' | translate}}</option>
            <option value="cuatro">{{'gestion.admin.altaPlanes.cuatroColores' | translate}}</option>
            <option value="cinco">{{'gestion.admin.altaPlanes.cincoColores' | translate}}</option>
          </select>
        </div>

        @for (sem of newsemaforo; track sem; let i = $index) {
        <div style="display: flex; gap: 1%; width: 70%;">
          <div class="form-group" style="flex: 0 0 32% !important;">
            <label for="valor1Sem_{{i}}" class="form-label">
              {{'gestion.admin.altaPlanes.valor1' | translate}}
            </label>
            <input id="valor1Sem_{{i}}" type="number" class="form-input anchosInputsShort"
              formControlName="inputVal1Sem{{i}}" placeholder="{{'gestion.admin.altaPlanes.valorMinimo' | translate}}"
              value="{{sem.valor_00}}">
          </div>
          <div class="form-group" style="flex: 0 0 32% !important;">
            <label for="valor2Sem_{{i}}" class="form-label">
              {{'gestion.admin.altaPlanes.valor2' | translate}}
            </label>
            <input id="valor2Sem_{{i}}" type="number" class="form-input anchosInputsShort"
              formControlName="{{i === (newsemaforo.length-1)? 'inputVal2Sem4':'inputVal2Sem'+i}}"
              placeholder="{{'gestion.admin.altaPlanes.valorMaximo' | translate}}" (input)="intNumero(i)"
              value="{{sem.valor_01}}">
          </div>
          <div class="form-group" style="flex: 0 0 32% !important;">
            <label for="colorSem_{{i}}" class="form-label">
              {{'gestion.admin.altaPlanes.color' | translate}}
            </label>
            <select id="colorSem_{{i}}" formControlName="inputColor{{i}}" class="contentSelect anchosInputsShort"
              required>
              <option value="" disabled>{{'gestion.admin.altaPlanes.selectColor' | translate}}</option>
              <option value="rojo" (click)="setcolor(i, 'rojo')">🔴 {{'gestion.admin.altaPlanes.rojo' | translate}}
              </option>
              <option value="naranja" (click)="setcolor(i, 'naranja')">🟠 {{'gestion.admin.altaPlanes.naranja' |
                translate}}</option>
              <option value="amarillo" (click)="setcolor(i, 'amarillo')">🟡 {{'gestion.admin.altaPlanes.amarillo' |
                translate}}</option>
              <option value="verde" (click)="setcolor(i, 'verde')">🟢 {{'gestion.admin.altaPlanes.verde' | translate}}
              </option>
              <option value="azul" (click)="setcolor(i, 'azul')">🔵 {{'gestion.admin.altaPlanes.azul' | translate}}
              </option>
            </select>
          </div>
        </div>
        }

      </form>
    </div>

    <div modal-footer>
      <div class="w3-right">
        <div class="botonesModales" ngClass="{{puede_guardarEditSem()}}">
          <button mat-flat-button color="success" (click)="alertas('editSem')" style="height: 4vh;">
            {{'gestion.admin.altaPlanes.guardar' | translate}}
          </button>
        </div>
        <div class="botonesModales" [ngClass]="haysem()">
          <button mat-stroked-button color="success2" (click)="cerrarForm()" style="height: 4vh;">
            {{'gestion.admin.altaPlanes.cancelar' | translate}}
          </button>
        </div>
      </div>
    </div>
  </app-modal>

</div>